import GreyBlackField, { GreyBlackFieldProps, HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import CaminoPeopleTeamIcon from "components/Icon/CaminoPeopleTeamIcon";
import BaselinePeopleOutline from "components/Icon/Iconify/BaselinePeopleOutline";
import OutlinePersonPin from "components/Icon/Iconify/OutlinePersonPin";
import RoundPersonOutline from "components/Icon/Iconify/RoundPersonOutline";
import {
  BuddyTag,
  ItTeamContactTag,
  ManagerTag,
  NewHireTag,
  PeopleTeamContactTag,
  RecruiterTag,
} from "components/Tag/UserTag/RoleTag";
import { NewHireJourney } from "models/v2/newHireJourney";

interface NewHireInfoProps extends Omit<GreyBlackFieldProps, "label"> {
  newHireJourney: NewHireJourney;
  includeIcon?: boolean;
  includeLink?: boolean;
  size?: "sm" | "md";
}

export function NewHireInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <GreyBlackField label="New Hire" icon={includeIcon ? RoundPersonOutline : null} gap="3px" {...rest}>
      <NewHireTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </GreyBlackField>
  );
}

export function HorizontalNewHireInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <HorizontalGreyBlackField label="New Hire" icon={includeIcon ? RoundPersonOutline : null} {...rest}>
      <NewHireTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </HorizontalGreyBlackField>
  );
}

export function ManagerInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <GreyBlackField label="Manager" icon={includeIcon ? OutlinePersonPin : null} gap="3px" {...rest}>
      <ManagerTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </GreyBlackField>
  );
}

export function HorizontalManagerInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <HorizontalGreyBlackField label="Manager" icon={includeIcon ? OutlinePersonPin : null} {...rest}>
      <ManagerTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </HorizontalGreyBlackField>
  );
}

export function PeopleTeamContactInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <GreyBlackField label="People Team Contact" icon={includeIcon ? CaminoPeopleTeamIcon : null} gap="3px" {...rest}>
      <PeopleTeamContactTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </GreyBlackField>
  );
}

export function HorizontalPeopleTeamContactInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <HorizontalGreyBlackField label="People Team Contact" icon={includeIcon ? CaminoPeopleTeamIcon : null} {...rest}>
      <PeopleTeamContactTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </HorizontalGreyBlackField>
  );
}

export function BuddyInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <GreyBlackField label="Buddy" icon={includeIcon ? BaselinePeopleOutline : null} gap="3px" {...rest}>
      <BuddyTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </GreyBlackField>
  );
}

export function HorizontalBuddyInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <HorizontalGreyBlackField label="Buddy" icon={includeIcon ? BaselinePeopleOutline : null} {...rest}>
      <BuddyTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </HorizontalGreyBlackField>
  );
}

export function RecruiterInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <GreyBlackField label="Recruiter" icon={includeIcon ? RoundPersonOutline : null} gap="3px" {...rest}>
      <RecruiterTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </GreyBlackField>
  );
}

export function HorizontalRecruiterInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <HorizontalGreyBlackField label="Recruiter" icon={includeIcon ? RoundPersonOutline : null} {...rest}>
      <RecruiterTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </HorizontalGreyBlackField>
  );
}

export function ItTeamContactInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <GreyBlackField label="IT Team Contact" icon={includeIcon ? OutlinePersonPin : null} gap="3px" {...rest}>
      <ItTeamContactTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </GreyBlackField>
  );
}

export function HorizontalItTeamContactInfo({
  newHireJourney,
  includeIcon = false,
  includeLink = true,
  size = "sm",
  ...rest
}: NewHireInfoProps) {
  return (
    <HorizontalGreyBlackField label="IT Team Contact" icon={includeIcon ? OutlinePersonPin : null} {...rest}>
      <ItTeamContactTag newHireJourney={newHireJourney} includeRoleName={false} size={size} />
    </HorizontalGreyBlackField>
  );
}
